"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _stylesModule2 = _interopRequireDefault(require("@components/Layout/Container/styles.module.scss"));

var _scss = require("@scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var GridWrapper = function GridWrapper(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      noGutters = _ref.noGutters,
      _ref$component = _ref.component,
      Tag = _ref$component === void 0 ? 'div' : _ref$component;
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    className: (0, _scss.cls)(_stylesModule["default"]['wrapper'], noGutters && _stylesModule2["default"]['no-gutters'], className)
  }, children);
};

var _default = GridWrapper;
exports["default"] = _default;